import { jsx, jsxs } from "react/jsx-runtime";
import { Slider, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
function LetterSpacingInput(props) {
  const { value, onChange, title, fontSizePixel } = props;
  const numericEmValue = useMemo(() => parseNumericEmValue(value, fontSizePixel), [value, fontSizePixel]);
  return /* @__PURE__ */ jsxs(Stack, { flex: "1 1 auto", children: [
    /* @__PURE__ */ jsx(Stack, { alignItems: "center", direction: "row", children: /* @__PURE__ */ jsxs(
      Typography,
      {
        sx: (theme) => ({
          color: theme.vars.palette.text.secondary,
          flex: "1 1 auto",
          fontSize: 16
        }),
        children: [
          title,
          ": ",
          numericEmValue.toFixed(5),
          "em"
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(
      Slider,
      {
        max: 0.1,
        min: -0.1,
        onChange: (_, v) => {
          const value2 = Array.isArray(v) ? v[0] : v;
          onChange(`${value2}em`);
        },
        size: "small",
        step: 25e-4,
        value: numericEmValue
      }
    )
  ] });
}
function parseUnit(value) {
  if (typeof value === "string") {
    if (value.endsWith("rem")) {
      throw new Error("Unsupported unit");
    }
    if (value.endsWith("em")) {
      return "em";
    }
    if (value.endsWith("px")) {
      return "px";
    }
    throw new Error("Unsupported unit");
  }
  return "px";
}
function parseNumericValue(value, unit) {
  if (unit === void 0) return 0;
  return typeof value === "string" ? Number.parseFloat(value.substring(0, value.lastIndexOf(unit))) : value;
}
function parseNumericEmValue(value, fontSize) {
  const unit = parseUnit(value);
  const rawValue = parseNumericValue(value, unit);
  switch (unit) {
    case "px":
      return rawValue / fontSize;
    case "em":
      return rawValue;
    default:
      throw new Error("Unexpected value");
  }
}
export {
  LetterSpacingInput
};
//# sourceMappingURL=LetterSpacingInput.js.map
